import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from "@angular/forms/forms";
import { schoolFullRegistrationRequestAdminService } from "../schoolfullregistrationrequestadmin/schoolfullregistrationrequestadmin.service";
import { HttpErrorResponse } from "@angular/common/http";
import { Router, ActivatedRoute } from "@angular/router";
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { RegistrationRequestFull } from 'src/app/Models/registrationrequestfull.model';
import { SchoolrequestlistService } from "./schoolrequestlist.service";
declare var $: any;


@Component({
  selector: 'app-schoolrequestlist',
  templateUrl: './schoolrequestlist.component.html',
  styleUrls: ['./schoolrequestlist.component.css']
})
export class SchoolrequestlistComponent implements OnInit {

  @ViewChild('RegistrationForm') RegistrationForm: NgForm;
  responseData: any;
  data: RegistrationRequestFull;
  TrusteeDetail: Array<any> = [];
  PrincipalDetail: Array<any> = [];
  ReqPrincipalDetail: Array<any> = [];
  OldPrincipalDetail: Array<any> = [];
  OldTrusteeDetail: Array<any> = [];
  OwnerDetail: Array<any> = [];
  OldOwnerDetail: Array<any> = [];
  hid_trusteeDetailID: any = -1;
  hid_principalDetailID: any = -1;
  hid_ownerDetailID: any = -1;
  hid_InfrastructureDetailID: any = -1;
  hid_EmployeeDetailID: any = -1;
  hid_EmployeeQualificationDetailID: any = -1;
  standardList: Array<any> = [];
  OldstandardList: Array<any> = [];
  standard: Array<any> = [];
  designations: any;
  DivisionDetail: Array<any> = [];
  StandardDetailReq: Array<any> = [];
  InfrastructureDetail: Array<any> = [];
  OldInfrastructureDetail: Array<any> = [];
  EmployeeDetail: Array<any> = [];
  OldEmployeeDetail: Array<any> = [];
  ClassroomDetail: Array<any> = [];
  OldClassroomDetail: Array<any> = [];
  EmployeeQualificationDetail: Array<any> = [];
  OldEmployeeQualificationDetail: Array<any> = [];
  sections: any;
  dropDownData: any;
  schoolname: any;
  infrastructures: any;
  employeetypes: any;
  qualifications: any;
  boards: any;
  mediums: any;
  standards: Array<any> = [];
  institutetypes: any;
  oldstandards: Array<any> = [];

  constructor(private service: schoolFullRegistrationRequestAdminService, private ReqService: SchoolrequestlistService, private router: Router, private toastr: ToastrService, private spinner: NgxSpinnerService, private rout: ActivatedRoute) { }

  ngOnInit(): void {
    if (localStorage.length == 0 || localStorage.getItem("token") == "" || localStorage.getItem("token") == undefined) {
      this.router.navigate(['/login']);
      return;
    }
    this.data = new RegistrationRequestFull();
    this.fillSection();
    this.fillBoard();
    this.fillMediums();
    this.fillInstituteType();
    setTimeout(() => { this.fillRegistrationDetail(); }, 1000);
  }

  fillBoard() {
    const data = {
    };
    this.service.fillBoard(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.boards = this.dropDownData.dropdownlist;
        this.boards.splice(0, 1);
      });
  }

  fillMediums() {
    const data = {
      HashCode: ""
    };
    this.service.fillMedium(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.mediums = this.dropDownData.dropdownlist;
        this.mediums.splice(0, 1);
        // this.data.Medium = 0;
      });
  }

  fillInstituteType() {
    const data = {
    };
    this.service.fillInstituteType(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.institutetypes = this.dropDownData.dropdownlist;
        this.institutetypes.splice(0, 1);
      });
  }

  fillStd(i) {
    var stdlist = this.sections[i]["StandardList"];
    var value = true;
    if (value) {
      for (var j = 0; j < stdlist.length; j++) {
        var c = 0;
        for (var l = 0; l < this.data.StandardDetails.length; l++) {
          if (stdlist[j]["value"] == this.data.StandardDetails[l]["StandardID"]) {
            c++;
            break;
          }
        }
        if (c > 0) {
          for (var k = 1; k <= stdlist[j]["noofyear"]; k++) {
            this.standardList[this.standardList.length] = { ...stdlist[j] };
            var displayyear = this.displayyear(k);
            this.standardList[this.standardList.length - 1]["text"] = this.standardList[this.standardList.length - 1]["text"] + " (" + displayyear + " " + this.standardList[this.standardList.length - 1]["coursetype"] + ")";
            this.standardList[this.standardList.length - 1]["year"] = k;
          }
        }
      }
    } else {
      for (var j = 0; j < this.standardList.length; j++) {
        if (this.standardList[j]["index"] == i) {
          this.standardList.splice(j, 1);
          j = -1;
        }
      }
    }
  }
  oldfillStd(i) {
    var stdlist = this.sections[i]["StandardList"];
    var value = true;
    if (value) {
      for (var j = 0; j < stdlist.length; j++) {
        var c = 0;
        for (var l = 0; l < this.data.OldStandardDetails.length; l++) {
          if (stdlist[j]["value"] == this.data.OldStandardDetails[l]["StandardID"]) {
            c++;
            break;
          }
        }
        if (c > 0) {
          for (var k = 1; k <= stdlist[j]["noofyear"]; k++) {
            this.OldstandardList[this.OldstandardList.length] = { ...stdlist[j] };
            var displayyear = this.displayyear(k);
            this.OldstandardList[this.OldstandardList.length - 1]["text"] = this.OldstandardList[this.OldstandardList.length - 1]["text"] + " (" + displayyear + " " + this.OldstandardList[this.OldstandardList.length - 1]["coursetype"] + ")";
            this.OldstandardList[this.OldstandardList.length - 1]["year"] = k;
          }
        }
      }
    } else {
      for (var j = 0; j < this.OldstandardList.length; j++) {
        if (this.OldstandardList[j]["index"] == i) {
          this.OldstandardList.splice(j, 1);
          j = -1;
        }
      }
    }
  }
  fillCourse() {
    this.standardList = [];
    this.standards = [];
    // this.documentList =[];
    //var stdlist = this.sections[i]["StandardList"];
    for (var q = 0; q < this.mediums.length; q++) {
      var m = $("#chkmedium" + q).prop("checked");
      if (m) {
        for (var g = 0; g < this.institutetypes.length; g++) {
          var c = $("#chkinstitute" + g).prop("checked");
          var insval = $("#chkinstitute" + g).val();
          if (c) {
            for (var p = 0; p < this.sections.length; p++) {
              var value = $("#chksection" + p).prop("checked");
              if (value) {
                var stdlist = this.sections[p]["StandardList"];
                for (var j = 0; j < stdlist.length; j++) {
                  var newtext = stdlist[j]["text"];
                  var mediumtext = this.mediums[q]["text"];
                  var instext = this.institutetypes[g]["text"];
                  if (insval == stdlist[j]["instituteTypeID"]) {

                    this.standards[this.standards.length] = { ...stdlist[j] };
                    this.standards[this.standards.length - 1]["MediumID"] = this.mediums[q]["value"];
                    this.standards[this.standards.length - 1]["medium"] = this.mediums[q]["text"];
                    this.standards[this.standards.length - 1]["text"] = newtext + " - " + instext + " - " + mediumtext + " Medium";
                    this.standards[this.standards.length - 1]["StandardID"] = stdlist[j]["value"];
                    this.standards[this.standards.length - 1]["InstituteTypeID"] = stdlist[j]["instituteTypeID"];
                    for (var k = 1; k <= stdlist[j]["noofyear"]; k++) {
                      var displayyear = this.displayyear(k);
                      this.standardList[this.standardList.length] = { ...this.standards[this.standards.length - 1] };
                      this.standardList[this.standardList.length - 1]["text"] = this.standardList[this.standardList.length - 1]["text"] + " (" + displayyear + stdlist[j]["coursetype"] + ")";
                      this.standardList[this.standardList.length - 1]["year"] = k;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

  }
  fillOldCourse() {
    this.OldstandardList = [];
    this.oldstandards = [];
    // this.documentList =[];
    //var stdlist = this.sections[i]["StandardList"];
    for (var q = 0; q < this.mediums.length; q++) {
      var m = $("#oldchkmedium" + q).prop("checked");
      if (m) {
        for (var g = 0; g < this.institutetypes.length; g++) {
          var c = $("#oldchkinstitute" + g).prop("checked");
          var insval = $("#oldchkinstitute" + g).val();
          if (c) {
            for (var p = 0; p < this.sections.length; p++) {
              var value = $("#oldchksection" + p).prop("checked");
              if (value) {
                var stdlist = this.sections[p]["StandardList"];
                for (var j = 0; j < stdlist.length; j++) {
                  var newtext = stdlist[j]["text"];
                  var mediumtext = this.mediums[q]["text"];
                  var instext = this.institutetypes[g]["text"];
                  if (insval == stdlist[j]["instituteTypeID"]) {

                    this.oldstandards[this.oldstandards.length] = { ...stdlist[j] };
                    this.oldstandards[this.oldstandards.length - 1]["MediumID"] = this.mediums[q]["value"];
                    this.oldstandards[this.oldstandards.length - 1]["medium"] = this.mediums[q]["text"];
                    this.oldstandards[this.oldstandards.length - 1]["text"] = newtext + " - " + instext + " - " + mediumtext + " Medium";
                    this.oldstandards[this.oldstandards.length - 1]["StandardID"] = stdlist[j]["value"];
                    this.oldstandards[this.oldstandards.length - 1]["InstituteTypeID"] = stdlist[j]["instituteTypeID"];
                    for (var k = 1; k <= stdlist[j]["noofyear"]; k++) {
                      var displayyear = this.displayyear(k);
                      this.OldstandardList[this.OldstandardList.length] = { ...this.oldstandards[this.oldstandards.length - 1] };
                      this.OldstandardList[this.OldstandardList.length - 1]["text"] = this.OldstandardList[this.OldstandardList.length - 1]["text"] + " (" + displayyear + stdlist[j]["coursetype"] + ")";
                      this.OldstandardList[this.OldstandardList.length - 1]["year"] = k;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  manageRegDoc(i, text, mediumID, sectionID, stdID) {
    this.spinner.show();
    var c = $("#chkStd" + i).prop("checked");
    if (c) {
      for (var j = 0; j < this.sections.length; j++) {
        if (this.sections[j]["value"] == sectionID) {
          var stdList = this.sections[j]["StandardList"];
          break;
        }
      }
      for (var j = 0; j < stdList.length; j++) {
        if (stdList[j]["value"] == stdID) {
          for (var k = 1; k <= stdList[j]["noofyear"]; k++) {
            this.standardList[this.standardList.length] = { ...stdList[j] };
            // this.standardList[this.standardList.length - 1]["ViewURL"] = "assets/images/no-image.jpg";
            // this.standardList[this.standardList.length - 1]["downloadURL"] = "assets/images/no-image.jpg";
            var displayyear = this.displayyear(k);
            this.standardList[this.standardList.length - 1]["StandardID"] = stdList[j]["value"];
            this.standardList[this.standardList.length - 1]["text"] = text + " (" + displayyear + " " + stdList[j]["coursetype"] + " " + stdList[j]["institutetype"] + ")";
            this.standardList[this.standardList.length - 1]["MediumID"] = mediumID;
            this.standardList[this.standardList.length - 1]["year"] = k;
          }
          break;
        }
      }
    }
    else {
      for (var j = 0; j < this.standardList.length; j++) {
        if (this.standardList[j]["StandardID"] == stdID && this.standardList[j]["MediumID"] == mediumID) {
          this.standardList.splice(j, 1);
          j--;
        }
      }
    }
    this.spinner.hide();
  }
  manageOldRegDoc(i, text, mediumID, sectionID, stdID) {
    this.spinner.show();
    var c = $("#chkStd" + i).prop("checked");
    if (c) {
      for (var j = 0; j < this.sections.length; j++) {
        if (this.sections[j]["value"] == sectionID) {
          var stdList = this.sections[j]["StandardList"];
          break;
        }
      }
      for (var j = 0; j < stdList.length; j++) {
        if (stdList[j]["value"] == stdID) {
          for (var k = 1; k <= stdList[j]["noofyear"]; k++) {
            this.OldstandardList[this.OldstandardList.length] = { ...stdList[j] };
            // this.standardList[this.standardList.length - 1]["ViewURL"] = "assets/images/no-image.jpg";
            // this.standardList[this.standardList.length - 1]["downloadURL"] = "assets/images/no-image.jpg";
            var displayyear = this.displayyear(k);
            this.OldstandardList[this.OldstandardList.length - 1]["StandardID"] = stdList[j]["value"];
            this.OldstandardList[this.OldstandardList.length - 1]["text"] = text + " (" + displayyear + " " + stdList[j]["coursetype"] + " " + stdList[j]["institutetype"] + ")";
            this.OldstandardList[this.OldstandardList.length - 1]["MediumID"] = mediumID;
            this.OldstandardList[this.OldstandardList.length - 1]["year"] = k;
          }
          break;
        }
      }
    }
    else {
      for (var j = 0; j < this.OldstandardList.length; j++) {
        if (this.OldstandardList[j]["StandardID"] == stdID && this.OldstandardList[j]["MediumID"] == mediumID) {
          this.OldstandardList.splice(j, 1);
          j--;
        }
      }
    }
    this.spinner.hide();
  }
  displayyear(i) {
    var j = i % 10,
      k = i % 100;
    if (j == 1 && k != 11) {
      return i + "st";
    }
    if (j == 2 && k != 12) {
      return i + "nd";
    }
    if (j == 3 && k != 13) {
      return i + "rd";
    }
    return i + "th";
  }
  fillSection() {
    const data = {
    };
    this.service.fillSection(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.sections = this.dropDownData.Sectionlist;
        // this.data.Section = 0;
      });
  }
  fillDiv(stdid, i, year) {
    var val = $('#std' + i + '_' + i).val();
    //$("#divlist" + stdid).empty();
    $("#divlist" + stdid + "_" + i + "_" + year).html('');
    if (val != "0" && val != "" && parseInt(val) > 0) {
      this.spinner.show();
      var t: string = '';
      for (var j = 0; j < val; j++) {

        // if (j == 0) {
        //   // t = '<div class="p-2 m-2" style="border: 1px solid black"> ';
        // }
        t +=
          // '<div class="form-group col-lg-3 col-md-3 col-3"> ' +
          '<label id="division' + stdid + '_' + j + '_' + i + '_' + year + '"></label> ' +
          //'</div>' +
          //'<div class="form-group col-lg-3 col-md-3 col-3"> ' +
          '<label id="studCount' + stdid + '_' + j + '_' + i + '_' + year + '"></label>, ';
        //'</div>' ;

      }
      // t += '</div>';

      $("#divlist" + stdid + "_" + i + "_" + year).append(t.substring(0, t.length - 2));
      this.spinner.hide();
    }
  }
  oldfillDiv(stdid, i, year) {
    var val = $("#oldstd" + i + '_' + i).val();
    //$("#divlist" + stdid).empty();
    $("#olddivlist" + stdid + "_" + i + "_" + year).html('');
    if (val != "0" && val != "" && parseInt(val) > 0) {
      this.spinner.show();
      var t: string = '';
      for (var j = 0; j < val; j++) {

        // if (j == 0) {
        //   // t = '<div class="p-2 m-2" style="border: 1px solid black"> ';
        // }
        t +=
          // '<div class="form-group col-lg-3 col-md-3 col-3"> ' +
          '<label id="olddivision' + stdid + '_' + j + "_" + i + "_" + year + '"></label> ' +
          //'</div>' +
          //'<div class="form-group col-lg-3 col-md-3 col-3"> ' +
          '<label id="oldstudCount' + stdid + '_' + j + "_" + i + "_" + year + '"></label>, ';
        //'</div>' ;

      }
      // t += '</div>';
      $("#olddivlist" + stdid + "_" + i + "_" + year).append(t.substring(0, t.length - 2));
      this.spinner.hide();
    }
  }
  setSudCount() {
    this.spinner.show();
    var std = 0;
    var oldstd = 0;
    this.standardList = []
    this.OldstandardList = []
    // for (var k = 0; k < this.sections.length; k++) {
    for (var l = 0; l < this.standards.length; l++) {
      $("#chkStd" + l).prop("checked", false);
      for (var m = 0; m < this.data.StandardDetails.length; m++) {
        if (std != this.data.StandardDetails[m]["StandardID"]) {
          if (this.standards[l]["value"] == this.data.StandardDetails[m]["StandardID"]
            && this.standards[l]["MediumID"] == this.data.StandardDetails[m]["MediumID"]) {
            std = this.data.StandardDetails[m]["StandardID"]

            $("#chkStd" + l).prop("checked", true);
            for (var k = 1; k <= this.standards[l]["noofyear"]; k++) {
              var displayyear = this.displayyear(k);
              this.standardList[this.standardList.length] = { ...this.standards[l] };
              this.standardList[this.standardList.length - 1]["text"] = this.standardList[this.standardList.length - 1]["text"] + " (" + displayyear + this.standards[l]["coursetype"] + " )";
              this.standardList[this.standardList.length - 1]["year"] = k;
            }
          }
        }
      }
    }
    for (var l = 0; l < this.oldstandards.length; l++) {
      $("#chkStd" + l).prop("checked", false);
      for (var m = 0; m < this.data.OldStandardDetails.length; m++) {
        if (oldstd != this.data.OldStandardDetails[m]["StandardID"]) {
          if (this.oldstandards[l]["value"] == this.data.OldStandardDetails[m]["StandardID"]
            && this.oldstandards[l]["MediumID"] == this.data.OldStandardDetails[m]["MediumID"]) {
            oldstd = this.data.OldStandardDetails[m]["StandardID"]

            $("#chkStd" + l).prop("checked", true);
            for (var k = 1; k <= this.oldstandards[l]["noofyear"]; k++) {
              var displayyear = this.displayyear(k);
              this.OldstandardList[this.OldstandardList.length] = { ...this.oldstandards[l] };
              this.OldstandardList[this.OldstandardList.length - 1]["text"] = this.OldstandardList[this.OldstandardList.length - 1]["text"] + " (" + displayyear + this.oldstandards[l]["coursetype"] + " )";
              this.OldstandardList[this.OldstandardList.length - 1]["year"] = k;
            }
          }
        }
      }
    }
    setTimeout(() => {

      var std = 0;
      var oldstd = 0;
      for (var j = 0; j < this.standardList.length; j++) {
        var c = 0;
        for (var m = 0; m < this.data.StandardDetails.length; m++) {
          if (this.standardList[j]["value"] == this.data.StandardDetails[m]["StandardID"] && this.standardList[j]["year"] == this.data.StandardDetails[m]["Year"]
            && this.standardList[j]["MediumID"] == this.data.StandardDetails[m]["MediumID"]) {
            c++;
          }
        }
        $("#std" + j + "_" + j).val(c);
        this.fillDiv(this.standardList[j]["value"], j, this.standardList[j]["year"]);
        var p = 0;

        for (var k = 0; k < this.data.StandardDetails.length; k++) {
          if (this.standardList[j]["value"] == this.data.StandardDetails[k]["StandardID"] && this.standardList[j]["year"] == this.data.StandardDetails[k]["Year"]
            && this.standardList[j]["MediumID"] == this.data.StandardDetails[k]["MediumID"]) {
            $("#division" + this.standardList[j]["value"] + "_" + p + "_" + j + "_" + this.data.StandardDetails[k]["Year"]).text("(" + this.data.StandardDetails[k]["DivisionName"]);
            $("#studCount" + this.standardList[j]["value"] + "_" + p + "_" + j + "_" + this.data.StandardDetails[k]["Year"]).text(" - " + this.data.StandardDetails[k]["StudentCount"] + ")");
            p++;
          }
        }
      }

      for (var i = 0; i < this.OldstandardList.length; i++) {
        var d = 0;
        for (var n = 0; n < this.data.OldStandardDetails.length; n++) {
          if (this.OldstandardList[i]["value"] == this.data.OldStandardDetails[n]["StandardID"] && this.OldstandardList[i]["year"] == this.data.OldStandardDetails[n]["Year"]
            && this.OldstandardList[i]["MediumID"] == this.data.OldStandardDetails[n]["MediumID"]) {
            d++;
          }
        }
        $("#oldstd" + i + "_" + i).val(d);

        this.oldfillDiv(this.OldstandardList[i]["value"], i, this.OldstandardList[i]["year"]);
        var q = 0;

        for (var l = 0; l < this.data.OldStandardDetails.length; l++) {
          if (this.OldstandardList[i]["value"] == this.data.OldStandardDetails[l]["StandardID"] && this.OldstandardList[i]["year"] == this.data.OldStandardDetails[l]["Year"]
            && this.OldstandardList[i]["MediumID"] == this.data.OldStandardDetails[l]["MediumID"]) {
            $("#olddivision" + this.OldstandardList[i]["value"] + "_" + q + "_" + i + "_" + this.data.OldStandardDetails[l]["Year"]).text("(" + this.data.OldStandardDetails[l]["DivisionName"]);
            $("#oldstudCount" + this.OldstandardList[i]["value"] + "_" + q + "_" + i + "_" + this.data.OldStandardDetails[l]["Year"]).text(" - " + this.data.OldStandardDetails[l]["StudentCount"] + ")");
            q++;
          }
        }
      }
      this.spinner.hide();
    }, 500);
  }

  fillClassRooms() {
    if (this.data.NoOfClassroom > 0) {
      $("#divClassRoom").html('');
      this.spinner.show();
      var t: string = '';
      for (var j = 0; j < this.data.NoOfClassroom; j++) {
        // if (j == 0) {
        //   t = '<div class="p-2 m-2" style="border: 1px solid black"> ';
        // }
        var roomname = "";
        var roomsize = "";
        if (this.data.ClassroomDetail != undefined && this.data.ClassroomDetail[j] != undefined) {
          if (this.data.ClassroomDetail[j]["ClassroomName"] != undefined)
            roomname = this.data.ClassroomDetail[j]["ClassroomName"]

          if (this.data.ClassroomDetail[j]["ClassroomSize"] != undefined)
            roomsize = this.data.ClassroomDetail[j]["ClassroomSize"]
        }
        // t += '<div class="row mt-2"> ' +
        //   '<div class="form-group col-lg-4 col-md-12 col-12"> ' +
        //   ' <label><b>Classroom name</b><span class="text-danger">*</span></label> ' +
        //   ' <input name="classroomname' + j + '" id="classroomname' + j + '" autocomplete="off" class="form-control" type="text" value="' + roomname + '" placeholder="Enter classroom name" maxlength="50"  /> ' +
        //   '</div>' +
        //   '<div class="form-group col-lg-4 col-md-12 col-12"> ' +
        //   ' <label><b>Classroom size (Format : Length x Width)</b><span class="text-danger">*</span></label> ' +
        //   ' <input type="text" class="form-control" name="classroomsize' + j + '" autocomplete="off" id="classroomsize' + j + '" value="' + roomsize + '" placeholder="Enter classroom size (Format : Length x Width)"  maxlength="15" /> ' +
        //   '</div>' +
        //   '</div>';
        t += '(<label  name="classroomname' + j + '" id="classroomname' + j + '">' + roomname + '</label> -' +
          '<label  name="classroomsize' + j + '" id="classroomsize' + j + '">' + roomsize + '</label>), ';
      }
      //t += '</div>';
      $("#divClassRoom").append(t.substring(0, t.length - 2));
      this.spinner.hide();
    }
  }

  OldfillClassRooms() {
    if (this.data.OldNoOfClassroom > 0) {
      $("#divOldClassRoom").html('');
      this.spinner.show();
      var t: string = '';
      for (var j = 0; j < this.data.OldNoOfClassroom; j++) {
        // if (j == 0) {
        //   t = '<div class="p-2 m-2" style="border: 1px solid black"> ';
        // }

        var roomname = "";
        var roomsize = "";
        if (this.data.OldClassroomDetail != undefined && this.data.OldClassroomDetail[j] != undefined) {
          if (this.data.OldClassroomDetail[j]["ClassroomName"] != undefined)
            roomname = this.data.OldClassroomDetail[j]["ClassroomName"]

          if (this.data.OldClassroomDetail[j]["ClassroomSize"] != undefined)
            roomsize = this.data.OldClassroomDetail[j]["ClassroomSize"]
        }
        // t += '<div class="row mt-2"> ' +
        //   '<div class="form-group col-lg-4 col-md-12 col-12"> ' +
        //   ' <label><b>Classroom name</b><span class="text-danger">*</span></label> ' +
        //   ' <input name="classroomname' + j + '" id="classroomname' + j + '" autocomplete="off" class="form-control" type="text" value="' + roomname + '" placeholder="Enter classroom name" maxlength="50"  /> ' +
        //   '</div>' +
        //   '<div class="form-group col-lg-4 col-md-12 col-12"> ' +
        //   ' <label><b>Classroom size (Format : Length x Width)</b><span class="text-danger">*</span></label> ' +
        //   ' <input type="text" class="form-control" name="classroomsize' + j + '" autocomplete="off" id="classroomsize' + j + '" value="' + roomsize + '" placeholder="Enter classroom size (Format : Length x Width)"  maxlength="15" /> ' +
        //   '</div>' +
        //   '</div>';
        t += '(<label  name="oldclassroomname' + j + '" id="oldclassroomname' + j + '">' + roomname + '</label> -' +
          '<label  name="oldclassroomsize' + j + '" id="oldclassroomsize' + j + '">' + roomsize + '</label>), ';
      }
      //t += '</div>';
      $("#divOldClassRoom").append(t.substring(0, t.length - 2));
      this.spinner.hide();
    }
  }

  fillRegistrationDetail() {
    this.spinner.show();
    const data = {
      HashCode: localStorage.getItem("HashCode"),
      YearID: localStorage.getItem("yearID")
    };
    this.ReqService.fillRegistrationDetail(data)
      .subscribe(data => {
        this.spinner.hide();
        this.responseData = data;

        if (this.responseData.status == false) {
          this.toastr.error(this.responseData.message);
          this.router.navigate(['/dashboard']);
          return
        }
        else {
          this.data = this.responseData;
          this.schoolname = " - " + this.responseData["SchoolName"]
          // for (var i = 0; i < this.sections.length; i++) {
          //   if (this.data.Section.includes(this.sections[i]["value"])) {
          //     $('#chksection' + i).prop("checked", true);
          //     this.fillStd(i);
          //     this.oldfillStd(i);
          //   }
          //   if (this.responseData.hasRequest > 0)
          //     $('#chksection' + i).prop("disabled", true);
          // }

          for (var i = 0; i < this.boards.length; i++) {
            if (this.data.Board.includes(this.boards[i]["value"])) {
              $('#chkBoard' + i).prop("checked", true);
            }
          }
          for (var i = 0; i < this.boards.length; i++) {
            if (this.data.OldBoard.includes(this.boards[i]["value"])) {
              $('#oldchkBoard' + i).prop("checked", true);
            }
          }
          for (var i = 0; i < this.mediums.length; i++) {
            if (this.data.Medium.includes(this.mediums[i]["value"])) {
              $('#chkmedium' + i).prop("checked", true);
            }
          }
          for (var i = 0; i < this.mediums.length; i++) {
            if (this.data.OldMedium.includes(this.mediums[i]["value"])) {
              $('#oldchkmedium' + i).prop("checked", true);
            }
          }
          for (var i = 0; i < this.institutetypes.length; i++) {
            if (this.data.InstituteTypeID.includes(this.institutetypes[i]["value"])) {
              $('#chkinstitute' + i).prop("checked", true);
              this.fillCourse();
            }
          }
          for (var i = 0; i < this.institutetypes.length; i++) {
            if (this.data.OldInstituteTypeID.includes(this.institutetypes[i]["value"])) {
              $('#oldchkinstitute' + i).prop("checked", true);
              this.fillOldCourse();
            }
          }
          for (var i = 0; i < this.sections.length; i++) {
            if (this.data.Section.includes(this.sections[i]["value"])) {
              $('#chksection' + i).prop("checked", true);
              this.fillCourse();
            }
          }
          for (var i = 0; i < this.sections.length; i++) {
            if (this.data.OldSection.includes(this.sections[i]["value"])) {
              $('#oldchksection' + i).prop("checked", true);
              this.fillOldCourse();
            }
          }
          var f = 0;
          for (var i = 0; i < this.sections.length; i++) {
            if (this.data.Section.includes(this.sections[i]["value"])) {
              $('#chksection' + i).prop("checked", true);
              if (parseInt(this.sections[i]["value"]) > 2) {
                f++;
              }
            }
          }
          this.spinner.show();
          this.data.DesignationID = 0;
          this.PrincipalDetail = this.data.PrincipalDetail;

          // for (var i = 0; i < this.PrincipalDetail.length; i++) {
          //   var jsondata  = JSON.parse(this.PrincipalDetail[i].PrincipalReqJson);
          //   console.log("jsondata",jsondata.principaldetailrequestlog);

          //   var jData = JSON.stringify(jsondata.principaldetailrequestlog);
          //   var a = JSON.parse(jData);

          //   for (var p = 0; p < a; p++) {
          //     console.log("Test Data", a[p]);
          //   }


          //   // console.log("json", jsondata.principaldetailrequestlog.substring(1, jsondata.principaldetailrequestlog.length-1));
          //   this.ReqPrincipalDetail.push("[" + jsondata.principaldetailrequestlog.substring(1, jsondata.principaldetailrequestlog.length-1) + "]");
          // }
          // console.log("reqprincipal",this.ReqPrincipalDetail);
          this.OldPrincipalDetail = this.data.OldPrincipalDetail;
          this.OwnerDetail = this.data.OwnerDetail;
          this.OldOwnerDetail = this.data.OldOwnerDetail;
          this.OldTrusteeDetail = this.data.OldTrusteeDetail;
          this.TrusteeDetail = this.data.TrusteeDetail;
          // console.log("trustee", this.TrusteeDetail);
          // var onlyInA = this.TrusteeDetail.filter(this.comparer(this.OldTrusteeDetail));
          // var onlyInB = this.OldTrusteeDetail.filter(this.comparer(this.TrusteeDetail));
          // var result = onlyInA.concat(onlyInB);

          // console.log("result", result);
          // console.log("oldtrust", this.OldTrusteeDetail);

          // var result = onlyInA.concat(onlyInB);
          // console.log("result",result);
          //let difference = this.TrusteeDetail.filter(x => !this.OldTrusteeDetail.includes(x));
          this.InfrastructureDetail = this.data.InfrastructureDetail;
          this.OldInfrastructureDetail = this.data.OldInfrastructureDetail;
          this.EmployeeDetail = this.data.EmployeeDetail;
          this.OldEmployeeDetail = this.data.OldEmployeeDetail;
          this.ClassroomDetail = this.data.ClassroomDetail;
          this.OldClassroomDetail = this.data.OldClassroomDetail;
          // let difference = this.TrusteeDetail.filter(x => this.OldTrusteeDetail.indexOf(x) === -1);
          // console.log("diffe",difference);
          // let trustdifference = this.InfrastructureDetail.filter(x => this.OldInfrastructureDetail.indexOf(x) === -1);
          // console.log("infradiffe",trustdifference);
          setTimeout(() => { this.setSudCount(); this.spinner.hide(); }, 1000);
          this.EmployeeQualificationDetail = this.data.EmployeeQualificationDetail;
          this.OldEmployeeQualificationDetail = this.data.OldEmployeeQualificationDetail;

          this.data.EmployeeTypeID = 0;
          this.data.InfrastructureID = 0;
          this.data.QualificationID = 0;
        }
      }, (err: HttpErrorResponse) => {
        localStorage.clear();
        this.spinner.hide();
        this.toastr.error('Something Went Wrong');
        this.router.navigate(['/login']);
      });
  }
  redirectToList() {
    this.router.navigate(['/dashboard']);
  }
}
